import type React from 'react';

import type { SelectOptionDataType } from './types/SelectOptionDataType';
import type { SelectProps } from './types/SelectProps';

export type SelectDirection = 1 | -1;
export type SelectPlacement = 'bottom' | 'top';

export function resolveSelectedOption(
  value: SelectProps['value'],
  options: SelectOptionDataType[],
): SelectOptionDataType | null {
  if (value === undefined || value === null || value === '') {
    return null;
  }

  if (typeof value === 'object') {
    return value;
  }

  return options.find((option) => option.value === value) ?? null;
}

export function findEnabledIndex(
  options: SelectOptionDataType[],
  start: number,
  step: SelectDirection,
) {
  for (let index = start; index >= 0 && index < options.length; index += step) {
    if (!options[index]?.isDisabled) return index;
  }

  return -1;
}

export function findOptionByPrefix(
  options: SelectOptionDataType[],
  prefix: string,
  from: number,
) {
  if (options.length === 0) return -1;

  const start = ((from % options.length) + options.length) % options.length;
  for (let step = 0; step < options.length; step += 1) {
    const index = (start + step) % options.length;
    const option = options[index];
    if (option.isDisabled) continue;
    if (String(option.label).toLowerCase().startsWith(prefix)) return index;
  }

  return -1;
}

export function isTypeaheadKey(event: React.KeyboardEvent) {
  return (
    event.key.length === 1 &&
    event.key !== ' ' &&
    !event.ctrlKey &&
    !event.metaKey &&
    !event.altKey
  );
}

export function isRepeatedCharacter(query: string) {
  return query.length > 1 && [...query].every((char) => char === query[0]);
}
